<template>
    <ApolloQuery :query="ListMainMenuItems" :variables="{status: 'PUBLISHED', sortOn: 'priority'}" v-slot="{ result: { data } }" :tag="null">

      <transition name="menu-transition">
        <aside class="fill-height absolute pa-md-16" v-show="value">

          <div class="fill-height absolute">
            <AnimatedClouds />
            <div class="bg-video-overlay absolute" />
          </div>

          <transition>
            <seo-v-img :key="overItem.id" v-if="overItem" class="over-image" :src="overItem ? `/media/${overItem.image.id}` : null" height="100vh" width="80vw" contain />
          </transition>

          <div class="absolute clouds" />

          <v-row class="fill-height" :class="{'flex-nowrap': $vuetify.breakpoint.mdAndUp }">

            <v-col cols="12" md="2" :class="{'fill-height': $vuetify.breakpoint.mdAndUp}" class="pt-16 pt-md-0 mr-md-12 pl-12 pl-md-0">
              <v-row no-gutters :class="{'fill-height': $vuetify.breakpoint.mdAndUp}" align="end" justify="start" :align-content="$vuetify.breakpoint.mdAndUp ? 'end' : null">
                <v-col align-self="end" cols="auto" md="12" class="shrink">
                  <v-btn
                    data-cursor-target="center center"
                    text
                    class="social-btn link-about mb-md-16"
                    @click="$root.soundManager.playClick()"
                    :to="{name: 'About', params: {language:$language.current}}"
                    @click.native="$emit('input', false)"
                    @mouseenter="hoverAbout++"
                  >
                    <CharSplitText :transition-key="hoverAbout" transition="hover" :text="$root.siteSettings.aboutPageTitle" />
                  </v-btn>
                </v-col>
                <v-col align-self="end" cols="auto" md="12" class="shrink">
                  <v-btn
                    rel="noopener"
                    aria-label="Vogue Website"
                    data-cursor-target="center center"
                    text
                    class="social-btn mt-md-16"
                    @click="$root.soundManager.playClick()"
                    href="https://www.vogue.it"
                    target="_blank"
                    @mouseenter="hoverWebsite++"
                  >
                  <CharSplitText :transition-key="hoverWebsite" transition="hover" text="Vogue.it" />
                  </v-btn>
                </v-col>
                <v-col align-self="end" cols="auto" md="12" class="shrink">
                  <v-btn
                    rel="noopener"
                    aria-label="Instagram"
                    data-cursor-target="center center"
                    text
                    class="social-btn"
                    @click="$root.soundManager.playClick()"
                    href="https://www.instagram.com/vogueitalia"
                    target="_blank"
                    @mouseenter="hoverIg++"
                  >
                    <CharSplitText :transition-key="hoverIg" transition="hover" text="Ig" />
                  </v-btn>
                </v-col>
                <v-col align-self="end" cols="auto" md="12" class="shrink">
                  <v-btn
                    rel="noopener"
                    aria-label="Facebook"
                    data-cursor-target="center center"
                    text
                    class="social-btn"
                    @click="$root.soundManager.playClick()"
                    href="https://www.facebook.com/VogueItalia"
                    target="_blank"
                    @mouseenter="hoverFb++"
                  >
                    <CharSplitText :transition-key="hoverFb" transition="hover" text="Fb" />
                  </v-btn>
                </v-col>
                <v-col align-self="end" cols="auto" md="12" class="shrink pt-0 pt-md-6" v-if="$root.siteSettings.instagramFilterURL">
                  <v-btn
                    rel="noopener"
                    aria-label="Intagram Filter"
                    data-cursor-target="center center"
                    text
                    class="social-btn"
                    @click="$root.soundManager.playClick()"
                    :href="$root.siteSettings.instagramFilterURL"
                    target="_blank"
                  >
                    <IGFilterIcon class="ig-filter-icon" />
                  </v-btn>
                </v-col>
              </v-row>
            </v-col>

            <v-col v-if="data" align-self="center" cols="12" md="auto" class="grow px-16 px-md-0" >
              <GenericMenuItem
                class="link-to-section"
                v-for="item in data.MainMenuItems.items"
                :key="item.id"
                :enabled="item.enabled"
                :to="{name: targets[item.target], language: $language.current}"
                @click="$emit('input', false); $root.soundManager.playClick()"
                @mouseover.native="overItem = item"
                @mouseout.native="overItem = null"
                >
                {{item[`${$language.current}Title`]}}
              </GenericMenuItem>
            </v-col>

            <v-col cols="12" md="auto" class="pl-12 pl-md-0">
              <v-row no-gutters :class="{'fill-height': $vuetify.breakpoint.mdAndUp}" align="start" justify="start" align-md="end" justify-md="end" :align-content="$vuetify.breakpoint.mdAndUp ? 'end' : null">
                <v-col cols="auto" md="12" class="shrink pb-md-16 mb-md-16" @mouseover="onMouseEnterLanguageSelector" @mouseout="onMouseLeaveLanguageSelector" data-cursor-target="center center">
                  <div class="language-cut" :class="{open: mouseOverLanguageSelector}">
                    <v-btn
                      :aria-label="`Switch Language to ${$language.current}`"
                      text
                      block
                      class="social-btn"
                      :to="{params: {language: $language.current}}"
                      @click.native="$emit('input', false); $root.soundManager.playClick()"
                      >
                      {{$language.current}}
                    </v-btn>
                    <v-btn
                      :aria-label="`Switch Language to ${$language.current === 'en' ? 'it' : 'en'}`"
                      text
                      block
                      class="social-btn"
                      :to="{params: {language: $language.current === 'en' ? 'it' : 'en'}}"
                      @click.native="$emit('input', false); $root.soundManager.playClick()"
                      >
                      {{$language.current === 'en' ? 'it' : 'en'}}
                    </v-btn>
                  </div>
                  <lottie :options="{animationData: LanguageAnim, loop: false}" :height="40" :width="50" @animCreated="handleAnimation"  />
                </v-col>
                <v-col cols="auto" md="12" class="shrink">
                  <v-btn
                    :aria-label="$root.soundManager.muteStatus.user.muted ? 'Un Mute': 'Mute'"
                    data-cursor-target="center center"
                    text
                    block
                    @click="$root.soundManager.muteStatus.user.muted ? $root.soundManager.unmute('user') : $root.soundManager.mute('user'); $root.soundManager.playClick()"
                  >
                    <VolumeIcon :class="{'no-anim': $root.soundManager.muteStatus.user.muted}" />
                  </v-btn>
                </v-col>
              </v-row>
            </v-col>

          </v-row>
        </aside>
      </transition>
    </ApolloQuery>
</template>

<script>
import ListMainMenuItems from '@/graphql/ListMainMenuItem.gql'
import GenericMenuItem from '@/atoms/GenericMenuItem'
import VolumeIcon from '@/atoms/VolumeIcon'
import AnimatedClouds from '@/atoms/AnimatedClouds'
import Lottie from 'vue-lottie'
import LanguageAnim from '@/assets/bodymovin/language-arrow.json'
import CharSplitText from '@/atoms/CharSplitText'
import IGFilterIcon from '@/assets/img/ig-filter.svg'

// import AudioAnimationData from '@/assets/bodymovin/audio.json'

export default {
  name: 'MainMenu',
  components: {
    GenericMenuItem,
    VolumeIcon,
    Lottie,
    AnimatedClouds,
    CharSplitText,
    IGFilterIcon
  },
  props: {
    value: {
      required: true
    }
  },
  methods: {
    onMouseEnterLanguageSelector (e) {
      this.mouseOverLanguageSelector = true
      this.languageArrowAnim.playSegments([this.languageArrowAnim.currentFrame, 27], true)
    },
    onMouseLeaveLanguageSelector (e) {
      this.mouseOverLanguageSelector = false
      this.languageArrowAnim.playSegments([this.languageArrowAnim.currentFrame, 0], true)
    },
    handleAnimation (anim) {
      this.languageArrowAnim = anim
      this.languageArrowAnim.stop()
      // this.languageArrowAnim.playSegments([1, 0], true)
    }
    // handleAudioAnimation (anim) {
    //   this.audioAnim = anim
    //   // this.audioAnim.stop()
    //   this.audioAnim.playSegments([0, 150], true)
    //   // this.audioAnim.playSegments([150, 240], true)
    // }
  },
  data () {
    return {
      ListMainMenuItems,
      mouseOverLanguageSelector: false,
      LanguageAnim,
      hoverAbout: 0,
      hoverWebsite: 0,
      hoverIg: 0,
      hoverFb: 0,
      // AudioAnimationData,
      overItem: null,
      targets: {
        talents: 'Talents',
        illustrators: 'Illustrators',
        socials: 'Socials',
        sponsors: 'Sponsors',
        initiatives: 'Initiatives',
        designers: 'Designers',
        media: 'Media'
      }
    }
  },
  watch: {
    // '$root.soundManager.isUserMuted' (value) {
    //   console.log('is user muted', value, this)
    //   if (!value) {
    //     this.audioAnim.loop = true
    //     this.audioAnim.playSegments([0, 150], true)
    //   } else {
    //     this.audioAnim.loop = false
    //     this.audioAnim.playSegments([this.audioAnim.currentFrame, 240], true)
    //   }
    // },
    $route (value) {
      this.$emit('input', false)
    }
  }
}
</script>

<style lang="scss" scoped>

.absolute {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  transform-origin: 50% 50%;
  // z-index: -1;
}

aside {
  // position: fixed;
  // height: 100%;
  // width: 100%;
  // top: 0;
  // left: 0;
  z-index: $z-menu !important;
  overflow-y: auto;
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch;
  background-color: $c-light-pink;
  // transform: translateX(0%);
}

.link-to-section {
  transform: translate3d(0, 0, 0); // ie11 requires this (!)
}

.link-about {
  font-family: $heading-font-family !important;
  font-size: 1.5625rem !important;
  letter-spacing: 0;

  // @include breakpoint('lg-and-down') {
  //   font-size: 1.3rem !important;
  // }
  @include breakpoint('sm-and-down') {
    font-size: 1.1rem !important;
  }
}

::v-deep {
  .v-btn__content {
    text-transform: none !important;
  }
}

.social-btn {
  min-width: auto !important;

  svg {
    color: map-get($shades, 'black');
    width: 18px;
    height: 18px;
  }

  path:not([fill]) {
    fill: currentColor !important;
  }

  path[stroke-width] {
    stroke: currentColor !important;
  }

}

.over-image {
  position: absolute;
  right: -100px;
  top: 0;
}

.bg-video-overlay {
  background-color: rgba(#fff, 0.4);
}

.clouds {
  top: 20%;
  background-image: url('../assets/letter/clouds.webp');
  background-size: cover;
  background-position: center top;

  .no-webp & {
    background-image: url('../assets/letter/clouds-min.png');
  }
}

.menu-transition-enter-active {
  transition: all 1s $ease-out-quad, opacity 0.4s $ease-out-quad;
}

.menu-transition-leave-active {
  transition: all 0.3s $ease-out-quad, opacity 0.4s $ease-out-quad;
}

.menu-transition-enter,
.menu-transition-leave-to {
  transform: scale3d(1.1, 1.1, 1.1);
  opacity: 0;
}

.language-cut {
  overflow: hidden;
  height: 36px;
  transition: height 0.8s $ease-out-quad;

  &.open {
    height: 64px;
  }
}

.split-text {
  pointer-events: none;
  margin-bottom: -0.4em;
  margin-left: -0.2em;

  ::v-deep {
    .word {
      overflow: visible;
    }
  }
}

.ig-filter-icon {
  width: 25px !important;
  height: 25px !important;
}
</style>
